import React, { useState, useEffect } from "react";

// plugin imports
import {
	Link,
	useTranslation,
	Trans,
	useI18next,
} from "@herob191/gatsby-plugin-react-i18next";
import { useStaticQuery, graphql } from "gatsby";

// style imports
import "./Footer.scss";

// context imports

// component imports

// util imports

// svg imports

// component

export const Footer = ({ preFooterCTA = true }) => {
	const { t } = useTranslation();
	const { language, languages, originalPath } = useI18next();

	const data = useStaticQuery(graphql`
		query FooterQuery {
			allMarkdownRemark(
				filter: { frontmatter: { slug: { nin: [null, "/"] } } }
				sort: { frontmatter: { title: ASC } }
			) {
				nodes {
					frontmatter {
						title
						slug
					}
					parent {
						... on File {
							name
						}
					}
				}
			}
			companyJson {
				name
				address
				city
				phone
				email
				openingHours {
					monday {
						open
						close
					}
					tuesday {
						open
						close
					}
					wednesday {
						open
						close
					}
					thursday {
						open
						close
					}
					friday {
						open
						close
					}
					saturday {
						open
						close
					}
					sunday {
						open
						close
					}
				}
			}
		}
	`);

	const currentLanguage = language;
	const navLinks = data.allMarkdownRemark.nodes.filter((node) => {
		const nameParts = node.parent.name.split(".");
		const fileLang =
			nameParts.length > 1 ? nameParts[nameParts.length - 1] : "es";
		return fileLang === currentLanguage;
	});
	const languageString = {
		es: "Esp",
		en: "Eng",
	};

	const company = data.companyJson || {};

	const [isAvailable, setIsAvailable] = useState(false);

	useEffect(() => {
		const checkAvailability = () => {
			const openingHours = data.companyJson.openingHours || {};
			const now = new Date();
			const days = [
				"sunday",
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
			];
			const currentDay = days[now.getDay()];
			const hours = openingHours[currentDay];

			if (!hours || !hours.open || !hours.close) {
				setIsAvailable(false);
				return;
			}

			const currentTime =
				now.getHours().toString().padStart(2, "0") +
				":" +
				now.getMinutes().toString().padStart(2, "0");

			if (currentTime >= hours.open && currentTime < hours.close) {
				setIsAvailable(true);
			} else {
				setIsAvailable(false);
			}
		};

		checkAvailability();
		const interval = setInterval(checkAvailability, 20000);
		return () => clearInterval(interval);
	}, [data]);

	return (
		<>
			<footer className="footer">
				<div className="footerInner">
					<div className="footerColumns">
						<div className="column">
							<span className="columnTitle uppercase">{t("Navegación")}</span>
							<nav>
								<ul>
									<li>
										<Link to="/">{t("Inicio")}</Link>
									</li>
									{navLinks.map((link, index) => (
										<li key={index}>
											<Link to={link.frontmatter.slug}>
												{link.frontmatter.title}
											</Link>
										</li>
									))}
								</ul>
							</nav>
						</div>
						<div className="column">
							<span className="columnTitle uppercase">
								{t("Contacto")}
								<span
									className={`badgeAvailable h3 small ${isAvailable ? "" : "busy"}`}
								>
									{!isAvailable && t("No")} {t("Disponible")}
								</span>
							</span>
							{/* <p>
							{company.address}, {company.city}
						</p> */}
							<p>
								<span className="h3 small">
									<Trans>Teléfono</Trans>
								</span>
								<br />
								<a href={`tel:${company.phone?.replace(/\s/g, "")}`}>
									{company.phone}
								</a>
							</p>
							<br />
							<p>
								<span className="h3 small">
									<Trans>Correo electrónico</Trans>
								</span>
								<br />
								<a href={`mailto:${company.email}`}>{company.email}</a>
							</p>
						</div>
						<div className="column">
							<img
								src="/media/bannerKDV.png"
								alt="Banner Kit Digital"
								className="bannerKD"
							/>
						</div>
					</div>
					<div className="footerBottom h3">
						<p className="uppercase">
							{new Date().getFullYear()}© {company.name}
						</p>
						<div className="legalLinks">
							<Link className="uppercase" to="/legal/aviso-legal">
								{t("Aviso legal")}
							</Link>
							<Link className="uppercase" to="/legal/privacidad">
								{t("Política de privacidad")}
							</Link>
							<Link className="uppercase" to="/legal/cookies">
								{t("Política de cookies")}
							</Link>
							{languages?.map((lng) => {
								if (lng !== currentLanguage && languageString[lng]) {
									return (
										<Link
											to={originalPath}
											language={lng}
											className={`uppercase ${
												lng === currentLanguage ? "active" : ""
											}`}
											key={lng}
										>
											{languageString[lng]}
										</Link>
									);
								}
								return null;
							})}
						</div>
						<p className="uppercase">
							<Trans>
								Web by{" "}
								<a
									href="https://telita.es/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Telita
								</a>
							</Trans>
						</p>
					</div>
				</div>
			</footer>
		</>
	);
};
